angular.module('eficienciaFiscalModule')
    .service('faturaServicoService', ['genericServiceHelper',
        function (serviceHelper) {
            serviceHelper({
                url: '/financeiro/fatura-servico-item/',
                screenId: '#financeiro',
                service: this,
                callFunctions: [],
                callFunctionConfig: {
                    method: "PATCH",
                    holder: "function"
                }
            });
        }
    ]);
